import { useLang, IMAGES } from "../../App";

export const Hero = () => {
  const { t } = useLang();
  return (
    <section className="relative pt-20 pb-24 overflow-hidden border-b border-[#1e293b]/60" data-testid="hero-section">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,#1e3a8a33,transparent_60%)] pointer-events-none"></div>
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row gap-12 items-start justify-between">
          <div className="max-w-2xl">
            <div className="mono text-xs tracking-[0.2em] uppercase text-[#fbbf24] mb-4 flex items-center gap-2">
              <span className="inline-block w-2 h-2 rounded-full bg-[#fbbf24] animate-pulse"></span>
              {t("hero.eyebrow")}
            </div>
            <h1 className="disp text-5xl sm:text-6xl lg:text-7xl font-black leading-[0.95] tracking-tight text-white mb-6" data-testid="hero-title">
              <span className="ln"><span>{t("hero.l1")}</span></span>
              <span className="ln"><span className="text-slate-300">{t("hero.l2")}</span></span>
              <span className="ln"><span className="text-[#fbbf24]">{t("hero.l3")}</span></span>
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed mb-8 max-w-xl" data-testid="hero-subtitle">
              {t("hero.sub")}
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="#apply"
                data-testid="hero-apply-btn"
                className="disp text-sm font-bold uppercase tracking-wider bg-[#fbbf24] text-[#070d1e] px-8 py-4 rounded hover:bg-[#f59e0b] shadow-lg shadow-[#fbbf24]/10 transition-all"
              >
                {t("hero.cta")}
              </a>
              <a
                href="#types"
                data-testid="hero-rates-btn"
                className="mono text-xs uppercase tracking-widest text-slate-300 hover:text-[#fbbf24] px-6 py-4 border border-slate-700 rounded transition-colors"
              >
                {t("hero.secondary")}
              </a>
            </div>
          </div>

          <div className="w-full lg:w-96 rounded-xl border border-slate-700/80 bg-slate-900/90 p-5 shadow-2xl relative overflow-hidden">
            <div className="h-56 rounded-lg relative overflow-hidden">
              <img
                src={IMAGES.hero}
                alt="Malaysian loan advisor consulting a business client"
                className="absolute inset-0 w-full h-full object-cover d1-hero-drift"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070d1e]/70 via-transparent to-[#070d1e]/20"></div>
              <div className="absolute bottom-3 left-3 right-3 bg-[#070d1e]/85 backdrop-blur-sm border border-slate-700 p-2.5 rounded flex items-center justify-between">
                <span className="mono text-[11px] text-slate-300">{t("hero.range")}</span>
                <span className="disp text-sm font-bold text-[#fbbf24]">RM 1k – RM 500k</span>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 mt-4 text-center">
              <div className="p-3 rounded bg-slate-800/60 border border-slate-700/50">
                <span className="block mono text-[10px] text-slate-400 uppercase">{t("hero.monthly")}</span>
                <span className="disp text-lg font-bold text-white">1.5%</span>
              </div>
              <div className="p-3 rounded bg-slate-800/60 border border-slate-700/50">
                <span className="block mono text-[10px] text-slate-400 uppercase">{t("hero.annual")}</span>
                <span className="disp text-lg font-bold text-white">8% – 18%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
